import React from 'react';
import { createPortal } from 'react-dom';
import closeSign from '../assets/fieldIcons/crossIcon.svg';
import './modal.scss';


let modalEl = document.getElementById('modal-root');
if (!modalEl) {
  const modalNode = document.createElement('DIV');
  modalNode.setAttribute('id', 'modal-root');
  document.body.appendChild(modalNode);
  modalEl = modalNode;
}


function GenericModal({ children, onClose, showClose = true, id="gen-modal-content", fullScreen }) {

  const overlayClicked = (e) => {
		if (e.target.className === 'overlay') {
		  onClose();
		} else {
		  return;
		}
  };

  return createPortal(
    <div className="gen-modal-comp" id = {id}>
      <div className="overlay" onClick={(e) => overlayClicked(e)}>
        { showClose && (
          <div className="close-icon">
            <img src={closeSign} alt="" onClick={() => onClose()} />
          </div>
        )}
        <div className="content" style={{height: fullScreen ? "100%" : "auto"}}>
          {children}
        </div>
      </div>
    </div>,
    modalEl,
  );
}

export default GenericModal;
